import { gql } from '@apollo/client'
import { useContext } from 'react'

import { ChooseFrequencyLaterSteps } from '../../choose-frequency-later-steps'
import { ChooseFrequencyLaterStepsContent } from '../../choose-frequency-later-steps/components'
import {
  ChooseFrequencyLaterContextProvider,
  useChooseOfferFrequencyLaterContext,
} from '../../choose-frequency-later-steps/context-provider'
import { ChooseFrequencyLaterModalSteps } from '../../choose-frequency-later-steps/types'
import { BoxLockContext } from '../../context'
import { ModalLock } from '../../dynamic-multiple-offers-switch-frequency-lock/components'
import { PaywallLock } from '../../paywall-lock'
import {
  Upgrade2StepCurrentLayoutLock_OfferLockDataFragment,
  Upgrade2StepCurrentLayoutLock_ViewerFragment,
} from './__generated__/current-layout.graphql'

export interface Upgrade2StepCurrentLayoutLockProps {
  offerLockData: Upgrade2StepCurrentLayoutLock_OfferLockDataFragment
  viewer: Upgrade2StepCurrentLayoutLock_ViewerFragment
}

export function Upgrade2StepCurrentLayoutLock({
  offerLockData,
  viewer,
}: Upgrade2StepCurrentLayoutLockProps) {
  const { componentType } = useContext(BoxLockContext)

  if (componentType === 'paywall') {
    return (
      <PaywallLock offerLockData={offerLockData}>
        <ChooseFrequencyLaterSteps
          offerLockData={offerLockData}
          viewer={viewer}
          componentType="paywall"
        />
      </PaywallLock>
    )
  }

  return (
    <ChooseFrequencyLaterContextProvider offerLockData={offerLockData} componentType="modal">
      <Upgrade2StepModalContent offerLockData={offerLockData} viewer={viewer} />
    </ChooseFrequencyLaterContextProvider>
  )
}

function Upgrade2StepModalContent({ offerLockData, viewer }: Upgrade2StepCurrentLayoutLockProps) {
  const { currentStep } = useChooseOfferFrequencyLaterContext()
  const isSecondStep = currentStep === ChooseFrequencyLaterModalSteps.SELECT_FREQUENCY

  const modalOfferLockData = isSecondStep
    ? {
        ...offerLockData,
        header: {
          ...offerLockData.header,
          title: offerLockData.header?.secondStepTitle || offerLockData.header?.title,
        },
      }
    : offerLockData

  return (
    <ModalLock offerLockData={modalOfferLockData} size="lg" headingSize="lg">
      <ChooseFrequencyLaterStepsContent offerLockData={offerLockData} viewer={viewer} />
    </ModalLock>
  )
}

Upgrade2StepCurrentLayoutLock.fragments = {
  offerLockData: gql`
    fragment Upgrade2StepCurrentLayoutLock_offerLockData on OfferLockData {
      header {
        title
        secondStepTitle
      }
      ...ModalLock_offerLockData
      ...PaywallLock_offerLockData
      ...ChooseFrequencyLaterSteps_offerLockData
    }
    ${ModalLock.fragments.offerLockData}
    ${PaywallLock.fragments.offerLockData}
    ${ChooseFrequencyLaterSteps.fragments.offerLockData}
  `,
  viewer: gql`
    fragment Upgrade2StepCurrentLayoutLock_viewer on Profile {
      ...ChooseFrequencyLaterSteps_viewer
    }
    ${ChooseFrequencyLaterSteps.fragments.viewer}
  `,
}
